import moment from 'moment';

export default {
  name: 'templateLifeEventTheme',
  subtitle: 'Themes are a collection of Encouragement Categories',
  isTemplate: true,
  isPublishable: true,
  uniqKey: '_id',
  crudMapping: {
    readMany: 'editorLifeEventThemes',
    readOne: 'lifeEventTheme',
    useTemplate: 'createThemeFromTemplate',
  },
  readOneSchema: {
    show: true,
  },
  readManySchema: {
    cellFormatter(value, object, fieldName) {
      if (fieldName === '_id') {
        return value
          ? moment(new Date(parseInt(value.substring(0, 8), 16) * 1000)).format(
            'MM/DD/YYYY',
          )
          : '';
      }
      return value;
    },
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
        },
        _id: {
          title: 'Created At',
          type: 'string',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      title: ' ',
      type: 'object',
      required: ['title', 'image', 'lifeEventCategoryIds', 'companyIds'],
      properties: {
        title: {
          type: 'string',
        },
        description: {
          type: 'string',
        },
        image: {
          type: 'string',
        },
        sortIndex: {
          type: 'number',
          default: 1000,
        },
        published: {
          type: 'boolean',
          default: true,
          title: 'Published',
        },
        hidden: {
          type: 'boolean',
          default: false,
          title: 'Hide from frontend',
        },
      },
    },
    uiSchema: {
      published: {
        'ui:widget': 'hidden',
      },
      image: {
        'ui:widget': 'imageWidget',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/curator/templateLifeEventTheme.js